import { get, last, uniqBy, pickBy, size, dropRight, compact } from "lodash";
import { getQuiz, getQuestion, getNextQuestion, getAnswer } from "../utils";

export const onPreviousQuestion = (state) => {
  const { quiz, question } = last(state.answers);

  return {
    ...state,
    current: { quiz, question },
    answers: dropRight(state.answers, 1),
    answer: [],
  };
};

export const onSubmitQuestion = (state, action) => {
  let {
    current: { quiz },
    quizzes,
  } = state;

  // Get the nextQuestion ID, or null
  const nextQuestion = getNextQuestionId(state);

  const question = nextQuestion
    ? // Get next question by ID
      getQuestion(quizzes, quiz, nextQuestion)
    : // Get next question sequentially, based upon index
      getNextQuestion(quizzes, quiz, state.current.question, state.country);

  const answer = action.skip ? [] : state.answer;

  const newState = {
    ...state,
    answers: [...state.answers, { ...state.current, answer }],
    answer: [],
  };

  if (question) {
    return { ...newState, current: getCurrentState(state, question) };
  }

  return { ...newState, completed: true };
};

// Get the ID for the next question in the quiz
function getNextQuestionId(state) {
  if (!state.answer.length) return null;

  // Get all answer objects
  let answers = state.answer.map((answer) =>
    getAnswer(
      state.quizzes,
      state.current.quiz,
      state.current.question,
      answer.id
    )
  );

  // Remove falsey values
  answers = compact(answers);

  // Unique array of answers, based upon nextQuestion
  answers = uniqBy(answers, "nextQuestion");

  // No nextQuestion ID specified, return null and we'll go sequentially
  if (size(answers) < 1) return null;

  // Set nextQuestion if all answers point to same question
  const nextQuestionIds = answers.map((a) => a.nextQuestion);

  // Check if all nextQuestionIds are the same
  const isSameNextQuestion = nextQuestionIds.every((id) => {
    return id === nextQuestionIds[0];
  });

  // Not the same next question Id, return null to go sequentially.
  if (!isSameNextQuestion) return null;

  const nextQuestionId = get(answers, "[0].nextQuestion", null);

  if (!nextQuestionId) return null;

  // Check the nextQuestion is available in our country
  const question = getQuestion(
    state.quizzes,
    state.current.quiz,
    nextQuestionId
  );

  let countries = get(question, "country");

  // No Countries selected, use nextQuestionId
  if (!countries) return nextQuestionId;

  // Filter to selected countries
  countries = pickBy(countries, (val) => val === true);

  if (!Object.keys(countries).length) return nextQuestionId;

  return state.country in countries ? nextQuestionId : null;
}

function getCurrentState(state, question) {
  const current = { quiz: state.current.quiz, question: question.id };

  if (question.type === "quiz") {
    current.quiz = question.quiz;

    const newQuiz = getQuiz(state.quizzes, current.quiz);

    current.question = newQuiz.questions[0].id;
  }

  return current;
}
